export default {
  props: {
    areaStyle: {
      type: [String, Object, Array],
      default: function _default() {
        return [];
      }
    },
    areaClass: {
      default: ''
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  computed: {},
  methods: {},
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};